// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type {
  SubscriptionsCustomer,
  SubscriptionsInvoices,
  SubscriptionsInvoiceSummary,
  SubscriptionsSubscription,
} from '../types';
import { createQueryKey } from '../utils/keys';

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const putSubscriptionMutationKey = ['putSubscription'] as const;
export const deleteSubscriptionMutationKey = ['deleteSubscription'] as const;
export const putCustomerMutationKey = ['putCustomer'] as const;
export const postCustomerMutationKey = ['postCustomer'] as const;
export const postSetupIntentMutationKey = ['postSetupIntent'] as const;
export const postSubscriptionPromoCodeMutationKey = [
  'postSubscriptionPromoCode',
] as const;
export const deleteSubscriptionPromoCodeMutationKey = [
  'deleteSubscriptionPromoCode',
] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getSubscriptionQueryKey = (workspace_id: number) =>
  createQueryKey<SubscriptionsSubscription>()([
    'workspaces',
    workspace_id,
    'subscriptions',
  ] as const);

export const getCustomerQueryKey = (workspace_id: number) =>
  createQueryKey<SubscriptionsCustomer>()([
    'workspaces',
    workspace_id,
    'subscriptions',
    'customer',
  ] as const);

export const getCustomerInvoicesQueryKey = (
  workspace_id: number,
  params?: { lastInvoiceId?: string; nextInvoiceID?: string }
) =>
  createQueryKey<SubscriptionsInvoices>()([
    'workspaces',
    workspace_id,
    'subscriptions',
    'customer',
    'invoices',
    params,
  ] as const);

export const getInvoiceSummaryQueryKey = (
  workspace_id: number,
  params?: { subscriptionPlan?: string }
) =>
  createQueryKey<SubscriptionsInvoiceSummary>()([
    'workspaces',
    workspace_id,
    'subscriptions',
    'invoiceSummary',
    params,
  ] as const);
